import { useEffect, useState } from "react";
import { useBaseAction } from "hooks/core/index";
import {
  ICustomReactSelectOption,
  ISelectOption,
} from "core/types/elements/ICustomReactSelectOption";
import { createItemLabel } from "core/utils/string";

type TProps<T> = {
  fetchOnLoad: boolean;
  url: string;
  tokenValue?: string;
  filter?: string;
  expand?: string;
  filterParam?: string;
  orderby?: string;
  formatLabel?: (item: T) => string;
};

const useSelectOptions = <T extends ISelectOption>({
  fetchOnLoad,
  url,
  tokenValue,
  filter,
  expand,
  filterParam,
  orderby,
  formatLabel,
}: TProps<T>) => {
  const { request } = useBaseAction();
  const [selectOptions, setSelectOptions] = useState<ICustomReactSelectOption[]>(
    [] as ICustomReactSelectOption[],
  );

  const mappingOptions = (data: T[]): ICustomReactSelectOption[] => {
    return data.map((item: T) => ({
      value: String(item?.id),
      label: formatLabel ? formatLabel(item) : createItemLabel(item),
      extraData: item,
    }));
  };

  // eslint-disable-next-line consistent-return
  const getOptions = async (requestFilter?: string, useLoader = true, transform = true) => {
    const data = (await request({
      method: "GET",
      url,
      tokenValue,
      useLoader,
      params: {
        $orderby: orderby || null,
        $filter:
          filterParam ||
          `isDeleted eq false${filter ? ` and ${filter}` : ""} ${
            requestFilter ? ` and ${requestFilter}` : ""
          }`,
        $expand: expand || null,
      },
    })) as T[];
    if (!transform) return data;

    if (Array.isArray(data)) setSelectOptions(mappingOptions(data));
  };

  useEffect(() => {
    if (fetchOnLoad) getOptions();
  }, []);

  return {
    getOptions,
    selectOptions,
  };
};

export default useSelectOptions;
